import { render, staticRenderFns } from "./PayMethod.vue?vue&type=template&id=2b5e4ccc&"
import script from "./PayMethod.vue?vue&type=script&lang=js&"
export * from "./PayMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports